// extracted by css-extract-rspack-plugin
export default {"NavWrapper":"GivingActionsRow_NavWrapper__f0seb"};